





























































import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				tabulkovaPozice: `${this.storeUri}/${editMutations.TYP_TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
		isTablPozDisabled() {
			return !this.VyrobekvozOzn;
		},
	},
	methods: {
		tablpozClear() {
			this.Tablpozice = null;
			this.TablpoziceText = null;
		},
		OnVyrobekvozOznChange() {
			this.tablpozClear();
		},
	},
});
